// Light Material-50 shades matching the Super Admin Role dropdown.
export const getGpsBadgeStyles = (level: string) => {
  const normalized = String(level || '').toLowerCase();
  if (normalized === 'off') {
    return { backgroundColor: '#ffebee', color: '#c62828', borderColor: '#ef9a9a' };
  }
  if (normalized === 'premium') {
    return { backgroundColor: '#e8eaf6', color: '#3949ab', borderColor: '#c5cae9' };
  }
  return { backgroundColor: '#e8f5e9', color: '#2e7d32', borderColor: '#a5d6a7' };
};

export const getMaxRecordsBadgeStyles = (value: number) => {
  if (value === 1000) {
    return { backgroundColor: '#ffebee', color: '#c62828', borderColor: '#ef9a9a' };
  }
  if (value === 25000) {
    return { backgroundColor: '#e8f5e9', color: '#2e7d32', borderColor: '#a5d6a7' };
  }
  if (value === 50000) {
    return { backgroundColor: '#e8eaf6', color: '#3949ab', borderColor: '#c5cae9' };
  }
  return { backgroundColor: '#fffde7', color: '#8d6e00', borderColor: '#ffe082' };
};

export const getOnOffBadgeStyles = (enabled: boolean) => {
  if (!enabled) {
    return { backgroundColor: '#ffebee', color: '#c62828', borderColor: '#ef9a9a' };
  }
  return { backgroundColor: '#e8f5e9', color: '#2e7d32', borderColor: '#a5d6a7' };
};
